<template lang="pug">
	.creative-voice-message
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :autosize="true", :width="720")
			.creative-voice-message
				ListView.full-width(:topPagerVisible="true", :showColumnHeaders="false", initialView="table", :columns="columns", :height="300", :searchVisible="true", :hideViewsSelection="true", 
					:getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadData")
					template(slot="left-actions")
						.font-big.upper.grey {{ $tCaption('Voice messages') }}
					template(v-slot:cell-template="{ data }")
						.flex-row.justify.space.align-center
							.flex-col.space
								.font-big.grey(v-if="data.Text", :title="data.Text") {{ $Data.limitText(data.Text, 40) }}
								span {{ $moment(data.Created).format('LLL') }}
							.flex-row.space.align-center.add-button(@click="processAddVoiceMessage(data)")
								.text.flex-row.align-center.center
									span {{ $tCaption('Add') }}
								.flex-row.center.align-center.icon
									fas(icon="arrow-right")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import ListView from 'app-core/ListView.vue';

	export default {
		translationCategory: 'creative.Detail',
		name: 'creative-voice-message',
		components: {
			Loader, Popup, DxButton, ListView
		},
		props: ['creative', 'opts'],
		data() {
			return {
				isLoading: false,
				popupVisible: false,
				columns: [
					{ fieldName: 'Text', cellTemplate: 'cell-template' }
				]
			};
		},
		computed: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.creativeVoiceMessage = this;
		},
		methods: {
			show() {
				this.popupVisible = false;
				this.$nextTick(() => {
					this.popupVisible = true;
				});
			},
			async loadData(pageIndex, limit, opts) {
				if (opts?.byKey) {
					return this.$Data.getExternalApi('VoiceMessage/List', `filterCriteria=${JSON.stringify(['Oid', '=', opts?.byKey])}&page=1`, 1);
				}

				let filter = [['ProcessingStatus', '=', 2], 'AND', ['MediaFile.Oid', '<>', null]];

				if (this.opts?.networkShowId) {
					filter.push(...['AND', ['NetworkShow.Oid', '=', this.opts.networkShowId]]);
				}

				if (opts?.filter?.filterValue) {
					filter.push(...['AND', ['Text', 'contains', opts?.filter?.filterValue]]);
				}

				let sorting = `&sorting=[{ selector: 'Created', desc: true }]`;
				return this.$Data.getExternalApi('VoiceMessage/List', `filterCriteria=${JSON.stringify(filter)}${sorting}&page=${pageIndex + 1}`, limit);
			},
			processAddVoiceMessage(voiceMessage) {
				this.popupVisible = false;
				this.$eventsBus.$emit('creative--add-media-from-media-file', {
					mediaFile: voiceMessage?.MediaFile,
					text: voiceMessage?.Text
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.creative-voice-message {
		.add-button {
			font-size: 14px;
			font-weight: 100;
			border: 1px solid #dedede;
			border-radius: 20px;
			cursor: pointer;
			transition: 0.2s;

			.text {
				padding-right: 4px;
				padding-left: 10px;
				transition: 0.2s;
			}

			.icon {
				width: 40px;
				height: 40px;
				background: #dedede;
				border-radius: 20px;
				transition: 0.2s;
				transform: scale(0.9);
			}

			&:hover {
				.icon {
					background: $base-accent;
					color: $base-bg;
					transform: scale(1.2);
					margin-left: 10px;
				}

				border: 1px solid $base-accent;

				.text {
					color: $base-accent;
				}
			}
		}
	}
</style>
